function ResponsiveBackgroundImage() {
	var self = this;
	this.elements = [];
	this.init();
}

ResponsiveBackgroundImage.prototype.init = function() {
	var self = this;
	$('.responsive-background:not(.lazy)').each(function() {
		self.bindElement($(this).find('img:not(.lazy)'));
	});
};

ResponsiveBackgroundImage.prototype.bindElement = function(selector) {
	var self = this;

	var new_image = new Image();

	var srcset = $(selector).attr('data-srcset');
	var sizes = $(selector).attr('data-sizes');
	var src = $(selector).attr('data-src');

	$(selector).on('load', function() {
		self.update(selector);
	});

	if (src !== 'undefined') {
		$(selector).attr('srcset', srcset);
		$(selector).attr('sizes', sizes);
		$(selector).attr('src', src);
		self.update(selector);
	}

};

ResponsiveBackgroundImage.prototype.update = function(element) {
	//console.log(element);
	if ($(element).length) {
		var src = typeof $(element).get(0).currentSrc !== 'undefined' ? $(element).get(0).currentSrc : $(element).get(0).src;
	    if (src && src != $(element).src) {
	    	$(element).closest('.responsive-background').css('background-image', 'url("'+src+'")');
	    }
	}
};
